import component from "../../legacy/unavailable-message"

export default component
